/**
 * Sample data for the Platform screen's dashboard rendering.
 *
 * Split out from Platform.tsx purely for size: the markup there is the densest
 * block in the canvas, and interleaving twenty literal rows with it made the
 * structure unreadable. The strings are the canvas's, verbatim.
 */

export const PLATFORM_SIDEBAR = [
  "CRM",
  "HRM",
  "Projects",
  "Finance",
  "Marketing",
  "AI Agents",
  "Reports",
  "Settings",
];

export interface PlatformStat {
  label: string;
  value: string;
  delta: string;
}

export const PLATFORM_STATS: PlatformStat[] = [
  { label: "Total Revenue", value: "$245,720", delta: "+12.5%" },
  { label: "New Leads", value: "1,540", delta: "+18.7%" },
  { label: "Active Projects", value: "24", delta: "+5" },
  { label: "Total Employees", value: "128", delta: "+8" },
];

/** Four weekly bars. These are the `[data-bar]` elements the chart grows. */
export const PLATFORM_BARS = [52, 76, 62, 98];
export const PLATFORM_WEEKS = ["W1", "W2", "W3", "W4"];

export interface PlatformTask {
  title: string;
  team: string;
  status: string;
  fg: string;
  bg: string;
}

export const PLATFORM_TASKS: PlatformTask[] = [
  {
    title: "Follow up with new leads",
    team: "Sales Team",
    status: "In Progress",
    fg: "#38E5FF",
    bg: "rgba(56,229,255,.12)",
  },
  {
    title: "Review marketing campaign",
    team: "Marketing Team",
    status: "Pending",
    fg: "#FFB224",
    bg: "rgba(255,178,36,.12)",
  },
  {
    title: "Approve Q3 hiring plan",
    team: "HR Team",
    status: "Done",
    fg: "#3DDC97",
    bg: "rgba(61,220,151,.12)",
  },
];

export const ASSISTANT_REPLIES = [
  "Paid search drove 62% of the +18.7% lift. Cost per lead fell to $41.",
  "Two reps are over capacity. Want me to rebalance?",
];

export const ASSISTANT_CHIPS = ["Draft follow-ups", "Forecast Q3"];
